export const zIndex = {
    desktopNav: "7000",
    mobileNav: "8000",
    burger: "9000"
}
